import { combineReducers } from 'redux';
import commissionDueIndex from './CommissionDueIndex/reducer';
import commissionDueShow from './CommissionDueShow/reducer';
import commissionPaidIndex from './CommissionPaidIndex/reducer';
import commissionPaidShow from './CommissionPaidShow/reducer';

export const LOAD_COMMISSION_SETTINGS =
  'CommissionPayout/LOAD_COMMISSION_SETTINGS';
export const SET_COMMISSION_PAYOUT_SETTINGS =
  'CommissionPayout/SET_COMMISSION_PAYOUT_SETTINGS';
export const SET_COMMISSION_PAYOUT_SETTINGS_FAILED =
  'CommissionPayout/SET_COMMISSION_PAYOUT_SETTINGS_FAILED';

export const loadCommissionPayoutSettings = () => ({
  type: LOAD_COMMISSION_SETTINGS
});

export const setCommissionPayoutSettings = payload => ({
  type: SET_COMMISSION_PAYOUT_SETTINGS,
  payload
});

export const commissionPayoutSettingsFailed = () => ({
  type: SET_COMMISSION_PAYOUT_SETTINGS_FAILED
});

const initialState = {};

const indexReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMMISSION_PAYOUT_SETTINGS:
      return {
        ...state,
        midMonthMinimum: action.payload.mid_month_minimum,
        endMonthMinimum: action.payload.end_month_minimum,
        wireFee: action.payload.wire_fee
      };
    case SET_COMMISSION_PAYOUT_SETTINGS_FAILED:
      return {
        ...state
      };

    default:
      return state;
  }
};

const commissionDue = combineReducers({
  index: commissionDueIndex,
  show: commissionDueShow
});

const commissionPaid = combineReducers({
  index: commissionPaidIndex,
  show: commissionPaidShow
});

export default combineReducers({
  index: indexReducer,
  commissionDue,
  commissionPaid
});
